import { TablerIcon } from '@tabler/icons-react';
import { Box, Flex, Text } from '@mantine/core';

type AccordionHeaderProps = {
  title: string;
  count: number;
  amount: number;
  currency: string;
  Icon: TablerIcon;
  isOpen: boolean;
};

export const AccordionHeader = ({
  title,
  count,
  amount,
  currency,
  Icon,
  isOpen,
}: AccordionHeaderProps) => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  });

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Flex align="center" gap="xs">
        <Box
          w={40}
          h={40}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            borderRadius: 8,
            border: '1.25px solid var(--mantine-color-gray-2)',
            boxShadow: 'var(--mantine-shadow-xs-with-inner)',
          }}
        >
          <Icon size={24} />
        </Box>
        <Box>
          <Text size="md" fw={600} c="gray.10">
            {title}
          </Text>
          <Text size="sm" fw={400} c="gray.7">
            {count} {count === 1 ? 'item' : 'items'}
          </Text>
        </Box>
      </Flex>
      <Flex align="center" gap="xs">
        <Text size="md" fw={600} c="gray.10">
          {formatter.format(amount)}
        </Text>
        <Text size="sm" fw={500} c="gray.7" miw={60} ta="right">
          {isOpen ? 'Close' : 'View'}
        </Text>
      </Flex>
    </Box>
  );
};
